import type { TableColumn } from '@consta/uikit/Table'
import { Table } from '@consta/uikit/Table'
import type { FC } from 'react'

import type { BaseHeaderRowType, BinaryHeaderType } from '../segyHelpers'
import css from './Setup.css'

const columnsBinaryHeader: TableColumn<BaseHeaderRowType>[] = [
  {
    title: 'POS',
    accessor: 'position',
    align: 'right',
    width: 65,
  },
  {
    title: 'VALUE',
    accessor: 'value',
    align: 'right',
    width: 65,
  },
  {
    title: 'NAME',
    accessor: 'description',
  },
]

export const BinaryHeaderTable: FC<{
  binaryHeader?: BinaryHeaderType
}> = ({ binaryHeader }) => {
  const convertedBinaryHeader =
    binaryHeader?.map(header => ({ ...header, position: header.position + 1 })) ?? []

  return (
    <Table
      className={css.codeFrameBinaryHeader}
      rows={convertedBinaryHeader}
      columns={columnsBinaryHeader}
      zebraStriped="odd"
      getCellWrap={() => 'break'}
      size="m"
      stickyHeader={true}
    />
  )
}
